export default "__VITE_ASSET__By6oELsq__"